export const DIFFERENCE_VALUES = {
  DLN_CREATED_ALL: 'Lieferung erstellt - Alle',
  DLN_CREATED_COST_CENTERS: 'Lieferung erstellt - Kostenstellen',
  DLN_CREATED_SITES: 'Lieferung erstellt - Standorte',
  DLN_SIGN_REMINDER_ALL: 'Am Ende des Tages - Alle',
  DLN_SIGN_REMINDER_COST_CENTERS: 'Am Ende des Tages - Kostenstellen',
  DLN_SIGN_REMINDER_SITES: 'Am Ende des Tages - Standorte',
} as const;
